var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProxy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m253.68 275.52v34.719c0 10.641 1.6797 22.398 11.762 32.48v12.32c-1.6797 2.8008-10.078 7.8398-19.602 10.641-20.719 6.7188-40.32 13.441-40.32 44.801v30.801h196.56v-30.801h17.359v-17.359h-19.039c-5.6016-16.238-20.16-21.281-36.961-26.879-5.6016-1.6797-11.762-3.9219-17.359-7.8398 3.9219-1.6797 8.3984-3.3594 13.441-5.0391l-5.6016-16.801c-3.9219 1.1211-7.2812 2.8008-10.641 3.9219 7.2812-8.3984 11.199-20.16 11.199-34.719v-30.801c0-28.559-21.281-49.281-50.398-49.281-29.68 0.55469-50.398 20.715-50.398 49.836zm131.6 132.16v3.3594 12.879l-161.84 0.003906v-13.441c0-17.922 6.7188-21.281 28-28.559 14.559-5.0391 31.359-13.441 31.359-28.559 5.6016 2.2383 13.441 3.3594 20.719 3.3594 7.2812 0 14.559-1.1211 20.719-3.3594 0 15.68 16.238 23.52 31.359 28.559 20.723 7.2773 30.242 10.078 29.684 25.758zm-48.16-132.16v30.801c0 20.719-9.5195 33.602-33.039 33.602-8.3984 0-17.359-2.2383-24.078-7.8398-6.1602-5.0391-8.3984-10.641-8.3984-21.84v-34.719c0-19.602 12.879-31.922 32.48-31.922 19.594 0 33.035 12.879 33.035 31.918zm126.56 58.242c16.801 6.1602 35.281 9.5195 45.359 22.398l-14 10.641c-6.1602-7.8398-22.398-11.199-37.52-16.801zm34.719 43.117 17.359-1.6797c0.55859 3.9219 0 6.1602 0 26.879 0 5.0391-3.9219 8.9609-8.9609 8.9609h-26.32v-17.359h17.359c0.5625-12.32 0.5625-14 0.5625-16.801zm-66.078 16.801h36.961v17.359h-36.961zm12.879-155.68 17.359-3.3594c1.1211 6.1602 1.1211 9.5195 1.1211 23.52 0 23.52 0 24.641-0.55859 29.121l-17.359-1.6797c0.55859-3.9219 0.55859-6.1602 0.55859-27.441 0-13.441 0-15.68-1.1211-20.16zm-64.398 20.16h-17.359c0-13.441-0.55859-20.719 2.8008-30.238 3.3594-8.9609 8.9609-16.238 16.238-21.281l10.078 14.559c-5.6016 3.9219-8.9609 8.9609-10.641 15.68-1.6797 4.4805-1.1172 7.2812-1.1172 21.281zm23.52-42.559-3.3594-17.359c8.3984-1.6797 18.48-1.6797 27.441 0.55859 10.641 2.8008 20.16 8.9609 26.32 17.359l-14 10.078c-3.9219-5.0391-9.5195-8.9609-16.238-10.641-6.7227-1.6758-14.004-1.6758-20.164 0.003906zm-35.84 89.039c-5.6016-10.641-5.6016-21.84-5.6016-29.68h17.359c0 22.398 6.7188 35.84 33.039 35.84 11.199 0 22.398-3.3594 28-12.879l15.121 8.9609c-1.6797 2.8008-3.9219 5.6016-6.1602 7.8398v12.32s0.55859 0.55859 1.1211 1.1211l-10.641 14c-8.9609-6.7188-8.3984-12.32-8.3984-16.801-5.0391 1.6797-11.762 2.8008-19.039 2.8008-6.7188 0-13.441-1.1211-20.16-2.8008 0 4.4805 0.55859 10.641-7.8398 16.801l-10.641-14c0.55859-0.55859 1.1211-0.55859 1.1211-1.1211v-12.879c-2.8008-2.8047-5.043-6.1641-7.2812-9.5234zm226.24-55.441c-14 0-25.762 8.9609-29.121 21.84h-22.961l0.003906-192.08c0-5.0391-3.9219-8.9609-8.9609-8.9609h-367.36c-5.0391 0-8.9609 3.9219-8.9609 8.9609v192.08h-22.961c-3.9219-12.879-15.68-21.84-29.121-21.84-16.801 0-30.801 13.441-30.801 30.801s13.441 30.801 30.801 30.801c14 0 25.762-8.9609 29.121-21.84h22.961v192.08c0 5.0391 3.9219 8.9609 8.9609 8.9609h366.8c5.0391 0 8.9609-3.9219 8.9609-8.9609l-0.003906-192.08h22.961c3.9219 12.879 15.68 21.84 29.121 21.84 16.801 0 30.801-13.441 30.801-30.801s-13.441-30.801-30.242-30.801zm-489.44 43.68c-7.2812 0-12.883-5.5977-12.883-12.879s5.6016-12.879 12.879-12.879c7.2812 0 12.879 5.6016 12.879 12.879 0.003906 7.2812-5.5977 12.879-12.875 12.879zm419.44 179.2h-349.44v-384.16h349.44zm70-179.2c-7.2812 0-12.879-5.6016-12.879-12.879 0-7.2812 5.6016-12.879 12.879-12.879 7.2812 0 12.879 5.6016 12.879 12.879 0.003906 7.2812-5.5977 12.879-12.879 12.879zm-349.44-170.24v-17.359c23.52 0 43.121 16.801 47.039 39.199h6.7188c3.3594 0 6.1602 1.6797 7.8398 4.4805 1.6797 2.8008 1.6797 6.1602 0 8.9609l-14.559 25.199c-1.6797 2.8008-4.4805 4.4805-7.8398 4.4805s-6.1602-1.6797-7.8398-4.4805l-14.559-25.199c-1.6797-2.8008-1.6797-6.1602 0-8.9609 1.6797-2.8008 4.4805-4.4805 7.8398-4.4805h4.4805c-3.9219-12.32-15.684-21.84-29.121-21.84zm-61.602 35.281c-1.6797-2.8008-1.6797-6.1602 0-8.9609l14.559-25.199c1.6797-2.8008 4.4805-4.4805 7.8398-4.4805s6.1602 1.6797 7.8398 4.4805l14.559 25.199c1.6797 2.8008 1.6797 6.1602 0 8.9609-1.6797 2.8008-4.4805 4.4805-7.8398 4.4805l-5.0352-0.003906c3.9219 12.879 15.68 21.84 29.121 21.84l-0.003906 17.363c-23.52 0-43.121-16.801-47.039-39.199h-6.7188c-2.8008-0.5625-5.6016-2.2422-7.2812-4.4805z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 644,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("use", {
    x: 90.550781,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 104.359375,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 123.347656,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 142.242188,
    y: 644,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 155.628906,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 174.617188,
    y: 644,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 204.410156,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 224.453125,
    y: 644,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.453125,
    y: 644,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 285.632812,
    y: 644,
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.304688,
    y: 644,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 316.898438,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336.945312,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 355.933594,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.742188,
    y: 644,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 383.125,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 412.109375,
    y: 644,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 435.09375,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 454.328125,
    y: 644,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 474.265625,
    y: 644,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 494.304687,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 513.542969,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 527.351562,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 672,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 82.183594,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.992188,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 115.226562,
    y: 672,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 154.152344,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 167.535156,
    y: 672,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 187.46875,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216.207031,
    y: 672,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 239.640625,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.878906,
    y: 672,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.8125,
    y: 672,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.492188,
    y: 672,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.015625,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.820312,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.058594,
    y: 672,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.65625,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.648438,
    y: 672,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.242188,
    y: 672,
    xlinkHref: "#d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProxy);
export default __webpack_public_path__ + "static/media/proxy.927516f30d8d7314bc91c9f0526de373.svg";
export { ForwardRef as ReactComponent };